import { SeasonSelector } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { unwrappedPlayerCompetitionAverageSeasonOptionsAtom } from '@/atoms/filters/player/playerCompetitionAverageFilters';
import { CompetitionAverageFilterPanel } from '@/components/filters/CompetitionAverageFilterPanel';
import { UserCompetitionSelect } from '@/components/filters/UserCompetitionSelect';
import { usePhysicalMetricsFeature } from '@/hooks/featureFlags';

export const PlayerCompetitionAveragePanel = () => {
  const seasonOptions = useAtomValue(unwrappedPlayerCompetitionAverageSeasonOptionsAtom);
  const physicalMetricsEnabled = usePhysicalMetricsFeature();

  return (
    <CompetitionAverageFilterPanel>
      <UserCompetitionSelect showTracking={physicalMetricsEnabled} />
      <SeasonSelector options={seasonOptions} isMulti />
    </CompetitionAverageFilterPanel>
  );
};
